import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack } from "@mui/material";
import { FC } from "react";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { JobInfoItem } from "@/features/job/components/job-detail/JobInfoItem";

type TJobBenefitDetailProps = {
  defaultValues?: Partial<TJobForm>;
};

export const JobBenefitDetail: FC<TJobBenefitDetailProps> = ({ defaultValues }) => {
  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="福利厚生" />} padding="24px" showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <JobInfoItem label="社宅・住居情報" value={defaultValues?.companyAccommodation} type="textArea" />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="特定技能2号支援" value={defaultValues?.specifiedSkillNo2} type="textArea" />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="その他福利厚生や宗教面配慮の有無等" value={defaultValues?.otherBenefits} type="textArea" isShowDivider={false} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="社会保険・雇用保険の加入状況" value={defaultValues?.insuranceStatus} isShowDivider={false} />
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
